import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Fog.svg",
  "use": "Fog.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Fog.svg\"><path d=\"M54,29a7,7,0,0,1-7,7H19a9,9,0,0,1-.9519-17.9487,10.9872,10.9872,0,0,1,20.4175-4.6348A7.9614,7.9614,0,0,1,48.8868,22.29,6.98,6.98,0,0,1,54,29ZM20,48H44a2,2,0,0,1,0,4H20a2,2,0,1,1,0-4Zm-2-6a2,2,0,0,1,2-2H44a2,2,0,0,1,0,4H20A2,2,0,0,1,18,42Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol